import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../Button/Button';
import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import './Page.scss';

const Page = ({title, subTitle, className, hasMin, headerActions, backButtonLabel, children}) => {
  return (
      <>
        <section className={`page ${className} ${hasMin && 'has-min'}`}>
          {backButtonLabel && <div className="action-bar page-header vertical">
                <Link to={'..'} relative={'path'}>
                  <Button isLink={true}>
                    <ArrowLeftIcon className={'heroicon-20'}/> {backButtonLabel}
                  </Button>
                </Link>
              </div>}
          {
              (title || subTitle) &&
              <header className={'header'}>
                <div className="header_content">
                  {
                      title && <h1 className="title">{title}</h1>
                  }
                  {
                      subTitle && <h2 className="subTitle">{subTitle}</h2>
                  }
                </div>
                <span className="spacer"></span>
                {
                    headerActions && headerActions
                }
              </header>
          }
          <section className="content">
            {
              children
            }
          </section>
        </section>
      </>
  );
};

export default Page;
